module.exports = __webpack_public_path__ + "media/images/favicon-32x32-980cb3dc25418b65c4616e92c9f37ed9.png";